import React, { useEffect, useState } from 'react';

//*MUI
import {Tabs , Tab , Checkbox } from '@mui/material';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import checked from "../../../Assets/Images/Common/checked.svg";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import DateComponent from "../../../Subcomponents/DateComponent";
import debounce from "lodash.debounce";

//*Redux
import { useDispatch , useSelector} from 'react-redux';
import action from '../../../Redux Store/actions';

//*files
import cssClasses from './AllLeads.module.css';
import Button from '../../../Subcomponents/Button';
import DropDown from '../../../Subcomponents/DropDown';
import SearchBar from '../../../Subcomponents/Search';
import {  getAllLeadsForSustenanceFromRpc, getProjectByProjectName } from '../../../Services/SustenanceService';
import { useParams } from 'react-router-dom';
import Leadcard from '../../../Subcomponents/Leadcard';
import { dismissLoader, presentLoader } from '../../../Services/loader';
import AddLead from '../../../Modals/AddLead/AddLead';
import InfiniteScroll from 'react-infinite-scroll-component';
import EmptyListIcon from "../../../Assets/Images/Common/EmptyListLeads.svg";
import PlusIcon from "../../Icons/PlusIcon";
import { getProjects, getUsers } from '../../../Services/Lead';
import { getAllCpForLaunch } from '../../../Services/ChannelPartner';
import { errorTost } from '../../../Services/Toast';
import { uniq, uniqBy } from 'lodash';

function AllLeads() {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const dispatch = useDispatch();
  const { projectId} = useParams();
  const [tabValue, setTabValue] = useState(0);
  const [sendTabValue, setSendTabValue] = useState("Token");
  const [showDropDown, setShowDropDown] = useState(false);
  const [selectedListDropDown, setSelectedListDropDown] = useState([]);
  const [SustenanceLeadsArray, setSustenanceLeadsArray] = useState([]);
  const [addLeadModal, setAddLeadModal] = useState(false);

  const [listOfDropDown, setListOfDropDown] = useState([
    // "Type of Lead",
    { label: "None", select: true },
    { label: "Date", select: false },
    { label: "CP", select: false },
    { label: "Sales", select: false },
    { label: "Project", select: false },
    { label: "Lead Quality", select: false },
    { label: "Status", select: false },
  ]);
  const [showAllStatusDropDown, setShowAllStatusDropDown] = useState(false);
  const [allStatusDropDown, setAllStatusDropDown] = useState([
    { label: "Token Payment Pending", value: false },
    { label: "Token Partial Payment Done", values: false },
    { label: "Token Payment Complete", values: false },
    { label: "Unit On Hold", values: false },
    { label: "Closed", values: false },
  ]);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(35);
  const [loadingStatus, setLoadingStatus] = useState(0);
  const [noLeadsPresent, setNoLeadsPresent] = useState(null);
  const [leadsCount, setLeadsCount] = useState(0);
  const [search, setSearch] = useState("");

  const [helperText, setHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState("Latest First");

  const [showDates, setShowDates] = useState(false);
  const [showAllCpDropDown, setShowAllCpDropDown] = useState(false);
  const [allCpDropDown, setAllCpDropDown] = useState([]);
  const [showAllSalesDropDown, setShowAllSalesDropDown] = useState(false);
  const [allSalesDropDown, setAllSalesDropDown] = useState([]);
  const [showAllProjectsDropDown, setShowAllProjectsDropDown] = useState(false);
  const [allProjectsDropDown, setAllProjectsDropDown] = useState([]);
  const [showAllLeadQualityDropDown, setShowAllLeadQualityDropDown] =
    useState(false);
  const [allLeadQualityDropDown, setAllLeadQualityDropDown] = useState([
    {
      label: "WARM",
      value: false,
    },
    {
      label: "HOT",
      value: false,
    },
    {
      label: "COLD",
      value: false,
    },
    {
      label: "LOST",
      value: false,
    },
  ]);

  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);

  //*token-holders-props
  const [selectedDates, setSelectedDate] = useState(null);
  const [selectedCP, setSelectedCP] = useState([]);
  const [selectedSales, setSelectedSales] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedLeadQuality, setSelectedLeadQuality] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);


  const [DropdownSearch , setDropDownSearch] = useState("");


  useEffect(() => {
    dispatch(action.activeMenu('sustenancelead'));
    getAllCp(DropdownSearch);
    getAllProject();
    getAllUser(DropdownSearch); //Sales
  }, []);

    useEffect(() => {
      setPageNumber(0);
      setLoadingStatus(0);
      setSustenanceLeadsArray([]);
      if (document.getElementById("scrollableDiv")) {
        document.getElementById("scrollableDiv").scrollTop = 0;
      }
      let obj = [{ label: "Token", value: false }];
      setAllStatusDropDown([...obj]);
      getAllSustenanceLeads(
        0,
        search,
        drpDownSelectedVal,
        selectDates,
        selectedDates,
        selectedCP,
        selectedSales,
        selectedProjects,
        selectedLeadQuality,
        selectedStatus
      );
  }, []);

  function getAllSustenanceLeads(_pageNumber,
    search,
    _drpDownSelectedVal,
    selectDates,
    selectedDates,
    selectedCP,
    selectedSales,
    selectedProjects,
    selectedLeadQuality,
    selectedStatus) {
    getProjectByProjectName(projectId).then((res) => {
      console.log('Project-Data',res.data[0].projectId)
      presentLoader();
      getAllLeadsForSustenanceFromRpc(
        projectId,
        _pageNumber * pageSize,
        _pageNumber * pageSize + pageSize - 1,
        search,
        _drpDownSelectedVal,
        selectDates,
        selectedDates,
        selectedCP,
        selectedSales,
        selectedProjects,
        selectedLeadQuality,
        selectedStatus,
        loggedInUser.userId)
        .then((resp) => {
        console.log('Project-Leads-data', resp)
        dismissLoader();
        console.log({ resp });
        setLeadsCount(resp.count);
        if (resp.count > 0) {
          setNoLeadsPresent(true);
        } else {
          setNoLeadsPresent(false);
        }
        if (resp.count > resp.data.length) {
          setLoadingStatus(0);
          setPageNumber(1);
        } else {
          setLoadingStatus(-1);
          setPageNumber(0);
        }
        resp.data = resp.data.map((el, index) => ({
          ...el,
          person: {
            name: el?.leadname,
            personId: el?.personid,
          },
          id:
            "VJ" +
            el?.leaddisplayid?.replace(
              el?.leaddisplayid?.substring(8, 12),
              "-" + el?.leaddisplayid?.substring(8, 12)
            ),
          createdAt: el?.created_at,
          last_updated_at: el?.last_updated_at,
          type: el?.leadtype,
          status: el?.leadstatus,
          leadId: el?.id,
          leadStatus: el?.leadresponse ? el?.leadresponse : "WARM",
          FOS: {
            name: el?.fosname ? el?.fosname : "-",
            fosId: el?.fosid ? el?.fosid : "-",
          },
          CP: {
            name: el?.cpname ? el?.cpname : "-",
            cpId: el?.cpid ? el?.cpid : "-",
          },
          Sales: {
            name: el?.salesname ? el?.salesname : "-", //Sie Visit
            userId: el?.salesid ? el?.salesid : "-",
            email: el?.useremail,
            contactNumber: el?.usercontactnumber,
          },
          unit: {
            status: '',
            allotmentDate: '',
            number: '',
          },
          project: {
            unitType: el?.unittype,
            name: el?.projectname,
          },
          leadDetails: {
            contactNumber: el?.leadcontactnumber,
            leadEmail:el?.leademail
          },
        }));
        setSustenanceLeadsArray([...resp.data]);
      }).catch((err) => {
        dismissLoader();
        console.log(err);
      })
    }).catch((err) => {
        console.log('Project-Data' , err)
    })
    setLoadingStatus(0);
}

function getAllCp(search) {
  getAllCpForLaunch(search)
    .then((resp) => {
      let tempArray = allCpDropDown;
      tempArray = resp.data.map((el, index) => {
        return {
          label: el.billingName,
          value: false,
          id: el.cpId,
        };
      });
      setAllCpDropDown(tempArray);
    })
    .catch((err) => {
      console.log(err);
    });
}
function getAllProject() {
  getProjects()
    .then((resp) => {
      let tempArray = allProjectsDropDown;
      tempArray = resp.map((el, index) => {
        return {
          label: el.projectName,
          value: false,
          id: el.projectId,
        };
      });
      setAllProjectsDropDown(tempArray);
    })
    .catch((err) => {
      console.log(err);
    });
}
function getAllUser(search) {
  getUsers(search)
    .then((resp) => {
      let tempArray = allSalesDropDown;
      tempArray = resp.map((el, index) => {
        return {
          label: el.name,
          value: false,
          id: el.userId,
        };
      });
      setAllSalesDropDown(tempArray);
    })
    .catch((err) => {
      console.log(err);
    });
}

function clearFilters(){
  setSustenanceLeadsArray([]);
  setSelectedListDropDown([]);
  setListOfDropDown((pre) => {
    pre = pre.map((m) => ({
      ...m,
      select: false,
    }));
    pre[0].select = true;
    return [...pre];
  });
  setAllCpDropDown((pre) => {
    pre = pre.map((m) => ({
      ...m,
      value: false,
    }));
    return [...pre];
  });
  setAllProjectsDropDown((pre) => {
    pre = pre.map((m) => ({
      ...m,
      value: false,
    }));
    return [...pre];
  });
  setAllSalesDropDown((pre) => {
    pre = pre.map((m) => ({
      ...m,
      value: false,
    }));
    return [...pre];
  });
  setAllLeadQualityDropDown((pre) => {
    pre = pre.map((m) => ({
      ...m,
      value: false,
    }));
    return [...pre];
  });
  setAllStatusDropDown((pre) => {
    pre = pre.map((m) => ({
      ...m,
      value: false,
    }));
    return [...pre];
  });
  setSelectedDate(null);
  setShowDropDown(false);
  setShowAllCpDropDown(false);
  setShowAllSalesDropDown(false);
  setShowAllProjectsDropDown(false);
  setShowAllLeadQualityDropDown(false);
  setShowAllStatusDropDown(false);
  setShowDates(false);
  setSelectedCP([]);
  setSelectedLeadQuality([]);
  setSelectedProjects([]);
  setSelectedSales([]);
  setSelectedStatus([]);
  setSelectDates((pre) => {
    pre[0].value = "";
    pre[1].value = "";
    return { ...pre };
  });

}
function funReturnRes(value) {
  if (value) {
    setPageNumber(0);
    setLoadingStatus(0);
    setSustenanceLeadsArray([]);
    getAllSustenanceLeads(
      0,
      search,
      drpDownSelectedVal,
      selectDates,
      selectedDates,
      selectedCP,
      selectedSales,
      selectedProjects,
      selectedLeadQuality,
      selectedStatus
    );
  }
}

function getMoreData() {
  if (loadingStatus !== 0) return;
  setLoadingStatus(1);
  getProjectByProjectName(projectId).then((res) => {
    console.log('Project-Data',res.data[0].projectId)
  presentLoader();
  getAllLeadsForSustenanceFromRpc(
    projectId,
    pageNumber * pageSize,
    pageNumber * pageSize + pageSize - 1,
    search,
    drpDownSelectedVal,
    selectDates,
    selectedDates,
    selectedCP,
    selectedSales,
    selectedProjects,
    selectedLeadQuality,
    selectedStatus,
    loggedInUser.userId
  )
    .then((resp) => {
      console.log("---->" , resp)
      dismissLoader();
      if (resp.count > resp.data.length + SustenanceLeadsArray.length) {
        setLoadingStatus(0);
        setPageNumber(pageNumber + 1);
      } else {
        setLoadingStatus(-1);
        setPageNumber(0);
      }
      if (resp.count > 0) {
        setNoLeadsPresent(true);
      } else {
        setNoLeadsPresent(false);
      }
      resp.data = resp.data.map((el, index) => ({
        ...el,
        person: {
          name: el?.leadname,
          personId: el?.personid,

        },
        id:
          "VJ" +
          el?.leaddisplayid?.replace(
            el?.leaddisplayid?.substring(8, 12),
            "-" + el?.leaddisplayid?.substring(8, 12)
          ),
        createdAt: el?.created_at,
        last_updated_at: el?.last_updated_at,
        type: el?.leadtype,
        status: el?.leadstatus,
        leadId: el?.id,
        leadStatus: el?.leadresponse ? el?.leadresponse : "WARM",
        FOS: {
          name: el?.fosname ? el?.fosname : "-",
          fosId: el?.fosid ? el?.fosid : "-",
        },
        CP: {
          name: el?.cpname ? el?.cpname : "-",
          cpId: el?.cpid ? el?.cpid : "-",
        },
        Sales: {
          name: el?.salesname ? el?.salesname : "-", //Sie Visit
          userId: el?.salesid ? el?.salesid : "-",
          email: el?.useremail,
          contactNumber: el?.usercontactnumber,
        },
        unit: {
          status: '',
          allotmentDate: '',
          number: '',
        },
        project: {
          unitType: el?.unittype,
          name: el?.projectname,
        },
        leadDetails: {
          contactNumber: el?.leadcontactnumber,
          leadEmail:el?.leademail
        },
      }));
      setSustenanceLeadsArray((pre) => [...pre, ...resp.data]);
    })
    .catch((err) => {
      dismissLoader();
      console.log(err.message);
      errorTost(err.message);
    });
  }).catch((err) => {
    console.log('Project-Data' , err)
})
  setLoadingStatus(0);
}


function leadAdded(respValue) {
  if (respValue) {
    setPageNumber(0);
    setLoadingStatus(0);
    setSustenanceLeadsArray([]);
    getAllLeadsForSustenanceFromRpc(
      0,
      sendTabValue,
      search,
      drpDownSelectedVal,
      selectDates,
      selectedDates,
      selectedCP,
      selectedSales,
      selectedProjects,
      selectedLeadQuality,
      selectedStatus
    );
  }
}

const debouncedFetchSearchData = debounce((e) => {
  setSustenanceLeadsArray([]);
  setSearch(e.target.value);
  getAllSustenanceLeads(
    0,
    sendTabValue,
    e.target.value,
    drpDownSelectedVal,
    selectDates,
    selectedDates,
    selectedCP,
    selectedSales,
    selectedProjects,
    selectedLeadQuality,
    selectedStatus
  );
}, 800);
         
  return (
    <div className="pageWrapper">
    <div className={cssClasses.wrapperAddLeads}>
      <div className={cssClasses.title}>Leads</div>
      <div>
        <Button
          style={{
            color: "#fff",
            backgroundColor: "#1570EF",
            fontSize: "1.4rem",
            lineHeight: "2rem",
            fontFamily: "Roboto-Regular",
          }}
          btnName={"Add Leads"}
          clicked={() => {
            setAddLeadModal(true);
            // console.log("clicked");
            // navigate("/home/Sustenance/ConfigureEvent/Inventory");
            // navigate("/home/Event/EventConfig/5435/Launch");
          }}
          btnIcon={<PlusIcon />}
          iconPosition={"left"}
        />
      </div>
    </div>
    <div className={cssClasses.wrapperFilters}>
      <div className={cssClasses.containerFilterSortBy}>
        <div className={cssClasses.wrapperFilter}>
          <div className={cssClasses.filterTitle}>Filter by</div>
          <div className={cssClasses.wrapperDropDown}>
            <div
              className={cssClasses.wrapperCustomiseDropDown}
              onClick={(e) => {
                e.stopPropagation();
                setShowDropDown(!showDropDown);
              }}
            >
              <div className={cssClasses.dropDownLabel}>
                <span className={cssClasses.dropDownLabelValue}>
                  {selectedListDropDown.join()}
                </span>
                {selectedListDropDown.length === 0 && (
                  <span className={cssClasses.dropDownLabelValue}>None</span>
                )}
              </div>
              {showDropDown && (
                <KeyboardArrowUpIcon className={cssClasses.dropDownIcon} />
              )}
              {showDropDown === false && (
                <KeyboardArrowDownIcon className={cssClasses.dropDownIcon} />
              )}
            </div>
            {showDropDown && (
              <ClickAwayListener
                onClickAway={() => {
                  setShowDropDown(false);
                }}
              >
                <div className={cssClasses.containerCustomiseDropDown}>
                  <div className={cssClasses.wrapperSelectAndCheckbox}>
                    <div className={cssClasses.wrapperEachSelect}>
                      {listOfDropDown.map((each, index) => {
                        return (
                          <div
                          key={`${each}_${index}`}
                            className={
                              each.select
                                ? cssClasses.selectedVal
                                : cssClasses.containerEachSelect
                            }
                          >
                            <div
                              className={cssClasses.eachSelect}
                              onClick={() => {
                                setListOfDropDown((pre) => {
                                  pre = pre.map((m) => ({
                                    ...m,
                                    select: false,
                                  }));
                                  // pre[index].select = true;
                                  return [...pre];
                                });
                                if (selectedDates != null) {
                                  setListOfDropDown((pre) => {
                                    pre[1].select = true;
                                    return [...pre];
                                  });
                                }
                                allCpDropDown.forEach((el) => {
                                  if (el.value) {
                                    setListOfDropDown((pre) => {
                                      pre[2].select = true;
                                      return [...pre];
                                    });
                                  }
                                });
                                allSalesDropDown.forEach((el) => {
                                  if (el.value) {
                                    setListOfDropDown((pre) => {
                                      pre[3].select = true;
                                      return [...pre];
                                    });
                                  }
                                });
                                allProjectsDropDown.forEach((el) => {
                                  if (el.value) {
                                    setListOfDropDown((pre) => {
                                      pre[4].select = true;
                                      return [...pre];
                                    });
                                  }
                                });
                                allLeadQualityDropDown.forEach((el) => {
                                  if (el.value) {
                                    setListOfDropDown((pre) => {
                                      pre[5].select = true;
                                      return [...pre];
                                    });
                                  }
                                });
                                allStatusDropDown.forEach((el) => {
                                  if (el.value) {
                                    setListOfDropDown((pre) => {
                                      pre[6].select = true;
                                      return [...pre];
                                    });
                                  }
                                });
                                if (each.label === "None") {
                                  setSelectedListDropDown([]);
                                  setSelectedCP([]);
                                  setSelectedLeadQuality([]);
                                  setSelectedSales([]);
                                  setSelectedProjects([]);
                                  setSelectedStatus([]);
                                  setSelectedDate(null);
                                  setSelectDates((pre) => {
                                    pre[0].value = "";
                                    pre[1].value = "";
                                    return { ...pre };
                                  });

                                  setListOfDropDown((pre) => {
                                    pre = pre.map((m) => ({
                                      ...m,
                                      select: false,
                                    }));
                                    pre[0].select = true;
                                    return [...pre];
                                  });
                                  if (
                                    selectDates.startDate === "" ||
                                    selectDates.endDate === ""
                                  ) {
                                    setListOfDropDown((pre) => {
                                      pre[1].select = false;
                                      return [...pre];
                                    });
                                  }
                                  allCpDropDown.forEach((el) => {
                                    el.value = false;
                                  });
                                  allSalesDropDown.forEach((el) => {
                                    el.value = false;
                                  });
                                  allProjectsDropDown.forEach((el) => {
                                    el.value = false;
                                  });
                                  allLeadQualityDropDown.forEach((el) => {
                                    el.value = false;
                                  });
                                  allStatusDropDown.forEach((el) => {
                                    el.value = false;
                                  });
                                  setShowAllCpDropDown(false);
                                  setShowAllSalesDropDown(false);
                                  setShowAllProjectsDropDown(false);
                                  setShowAllLeadQualityDropDown(false);
                                  setShowAllStatusDropDown(false);
                                  setShowDates(false);
                                  // setSelectDates((pre) => {
                                  //   pre[0].value = "";
                                  //   pre[1].value = "";
                                  //   return { ...pre };
                                  // });
                                } else if (each.label === "CP") {
                                  setShowAllCpDropDown(true);
                                  setShowAllSalesDropDown(false);
                                  setShowAllProjectsDropDown(false);
                                  setShowAllLeadQualityDropDown(false);
                                  setShowAllStatusDropDown(false);
                                  setShowDates(false);
                                } else if (each.label === "Sales") {
                                  setShowAllSalesDropDown(true);
                                  setShowAllCpDropDown(false);
                                  setShowAllProjectsDropDown(false);
                                  setShowAllLeadQualityDropDown(false);
                                  setShowAllStatusDropDown(false);
                                  setShowDates(false);
                                } else if (each.label === "Project") {
                                  setShowAllSalesDropDown(false);
                                  setShowAllCpDropDown(false);
                                  setShowAllProjectsDropDown(true);
                                  setShowAllLeadQualityDropDown(false);
                                  setShowAllStatusDropDown(false);
                                  setShowDates(false);
                                } else if (each.label === "Lead Quality") {
                                  setShowAllSalesDropDown(false);
                                  setShowAllCpDropDown(false);
                                  setShowAllProjectsDropDown(false);
                                  setShowAllLeadQualityDropDown(true);
                                  setShowAllStatusDropDown(false);
                                  setShowDates(false);
                                } else if (each.label === "Status") {
                                  setShowAllSalesDropDown(false);
                                  setShowAllCpDropDown(false);
                                  setShowAllProjectsDropDown(false);
                                  setShowAllLeadQualityDropDown(false);
                                  setShowAllStatusDropDown(true);
                                  setShowDates(false);
                                } else if (each.label === "Date") {
                                  setShowAllSalesDropDown(false);
                                  setShowAllCpDropDown(false);
                                  setShowAllProjectsDropDown(false);
                                  setShowAllLeadQualityDropDown(false);
                                  setShowAllStatusDropDown(false);
                                  setShowDates(true);
                                }
                              }}
                            >
                              {each.label}
                            </div>
                            {each.select && (
                              <img
                                src={checked}
                                alt={"checked"}
                                style={{ marginRight: "2rem" }}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>

                    <div className={cssClasses.wrapperCheckbox}>
                      {showAllCpDropDown &&
                        allCpDropDown.map((each, index) => {
                          return (
                            <FormGroup>
                              <FormControlLabel
                                sx={[
                                  {
                                    "& .MuiTypography-root": {
                                      fontFamily: "Inter-Medium !important",
                                      fontStyle: "normal",
                                      fontWeight: "400",
                                      fontSize: "1.6rem !important",
                                      lineHeight: "2.4rem !important",
                                      /* identical to box height, or 150% */

                                      /* Gray/900 */

                                      color: "#101828",
                                    },
                                  },
                                ]}
                                checked={each.value}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setAllCpDropDown((pre) => {
                                      pre[index].value = e.target.checked;
                                      selectedCP.push(each.id);
                                      return [...pre];
                                    });
                                  } else {
                                    setAllCpDropDown((pre) => {
                                      pre[index].value = e.target.checked;
                                      return [...pre];
                                    });
                                    setSelectedCP(
                                      selectedCP.filter(
                                        (id) => id !== each.id
                                      )
                                    );
                                  }
                                  let checkCpSelected = allCpDropDown.filter(
                                    ({ value }) => value === true
                                  );
                                  if (checkCpSelected.length > 0) {
                                    setListOfDropDown((pre) => {
                                      pre[2].select = true;
                                      return [...pre];
                                    });
                                    if (
                                      selectedListDropDown.find(
                                        (value) => value === "CP"
                                      ) === undefined
                                    ) {
                                      setSelectedListDropDown((pre) => {
                                        return [...pre, "CP"];
                                      });
                                    }
                                  } else {
                                    setListOfDropDown((pre) => {
                                      pre[2].select = false;
                                      return [...pre];
                                    });
                                    setSelectedListDropDown((pre) => [
                                      ...pre.filter(
                                        (value) => value !== "CP"
                                      ),
                                    ]);
                                  }
                                }}
                                control={
                                  <Checkbox
                                    sx={{
                                      "& .MuiSvgIcon-root": { fontSize: 28 },
                                    }}
                                  />
                                }
                                label={each.label}
                              />
                            </FormGroup>
                          );
                        })}
                      {showAllSalesDropDown &&
                        allSalesDropDown.map((each, index) => {
                          return (
                            <FormGroup>
                              <FormControlLabel
                                sx={[
                                  {
                                    "& .MuiTypography-root": {
                                      fontFamily: "Inter-Medium !important",
                                      fontStyle: "normal",
                                      fontWeight: "400",
                                      fontSize: "1.6rem !important",
                                      lineHeight: "2.4rem !important",
                                      /* identical to box height, or 150% */

                                      /* Gray/900 */

                                      color: "#101828",
                                    },
                                  },
                                ]}
                                checked={each.value}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setAllSalesDropDown((pre) => {
                                      pre[index].value = e.target.checked;
                                      selectedSales.push(each.id);
                                      return [...pre];
                                    });
                                  } else {
                                    setAllSalesDropDown((pre) => {
                                      pre[index].value = e.target.checked;
                                      return [...pre];
                                    });
                                    setSelectedSales(
                                      selectedSales.filter(
                                        (id) => id !== each.id
                                      )
                                    );
                                  }
                                  let checkSalesSelected =
                                    allSalesDropDown.filter(
                                      ({ value }) => value === true
                                    );
                                  if (checkSalesSelected.length > 0) {
                                    setListOfDropDown((pre) => {
                                      pre[3].select = true;
                                      return [...pre];
                                    });
                                    if (
                                      selectedListDropDown.find(
                                        (value) => value === "Sales"
                                      ) === undefined
                                    ) {
                                      setSelectedListDropDown((pre) => {
                                        console.log("pre: ", pre);
                                        return [...pre, "Sales"];
                                      });
                                    }
                                  } else {
                                    setListOfDropDown((pre) => {
                                      pre[3].select = false;
                                      return [...pre];
                                    });
                                    setSelectedListDropDown((pre) => [
                                      ...pre.filter(
                                        (value) => value !== "Sales"
                                      ),
                                    ]);
                                  }
                                }}
                                control={
                                  <Checkbox
                                    sx={{
                                      "& .MuiSvgIcon-root": { fontSize: 28 },
                                    }}
                                  />
                                }
                                label={each.label}
                              />
                            </FormGroup>
                          );
                        })}

                      {showAllProjectsDropDown &&
                        allProjectsDropDown.map((each, index) => {
                          return (
                            <FormGroup>
                              <FormControlLabel
                                sx={[
                                  {
                                    "& .MuiTypography-root": {
                                      fontFamily: "Inter-Medium !important",
                                      fontStyle: "normal",
                                      fontWeight: "400",
                                      fontSize: "1.6rem !important",
                                      lineHeight: "2.4rem !important",
                                      /* identical to box height, or 150% */

                                      /* Gray/900 */

                                      color: "#101828",
                                    },
                                  },
                                ]}
                                checked={each.value}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setAllProjectsDropDown((pre) => {
                                      pre[index].value = e.target.checked;
                                      selectedProjects.push(each.label);
                                      return [...pre];
                                    });
                                  } else {
                                    setAllProjectsDropDown((pre) => {
                                      pre[index].value = e.target.checked;
                                      return [...pre];
                                    });
                                    setSelectedProjects(
                                      selectedProjects.filter(
                                        (label) => label !== each.label
                                      )
                                    );
                                  }
                                  let checkProjectSelected =
                                    allProjectsDropDown.filter(
                                      ({ value }) => value === true
                                    );
                                  if (checkProjectSelected.length > 0) {
                                    setListOfDropDown((pre) => {
                                      pre[4].select = true;
                                      return [...pre];
                                    });
                                    if (
                                      selectedListDropDown.find(
                                        (value) => value === "Project"
                                      ) === undefined
                                    ) {
                                      selectedListDropDown.push("Project");
                                    }
                                  } else {
                                    setListOfDropDown((pre) => {
                                      pre[4].select = false;
                                      return [...pre];
                                    });
                                    setSelectedListDropDown([
                                      ...selectedListDropDown.filter(
                                        (value) => value !== "Project"
                                      ),
                                    ]);
                                  }
                                }}
                                control={
                                  <Checkbox
                                    sx={{
                                      "& .MuiSvgIcon-root": { fontSize: 28 },
                                    }}
                                  />
                                }
                                label={each.label}
                              />
                            </FormGroup>
                          );
                        })}
                      {showAllLeadQualityDropDown &&
                        allLeadQualityDropDown.map((each, index) => {
                          return (
                            <FormGroup>
                              <FormControlLabel
                                sx={[
                                  {
                                    "& .MuiTypography-root": {
                                      fontFamily: "Inter-Medium !important",
                                      fontStyle: "normal",
                                      fontWeight: "400",
                                      fontSize: "1.6rem !important",
                                      lineHeight: "2.4rem !important",
                                      /* identical to box height, or 150% */

                                      /* Gray/900 */

                                      color: "#101828",
                                    },
                                  },
                                ]}
                                checked={each.value}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setAllLeadQualityDropDown((pre) => {
                                      pre[index].value = e.target.checked;
                                      selectedLeadQuality.push(each.label);
                                      return [...pre];
                                    });
                                  } else {
                                    setAllLeadQualityDropDown((pre) => {
                                      pre[index].value = e.target.checked;
                                      return [...pre];
                                    });
                                    setSelectedLeadQuality(
                                      selectedLeadQuality.filter(
                                        (label) => label !== each.label
                                      )
                                    );
                                  }
                                  let checkLeadQualitySelected =
                                    allLeadQualityDropDown.filter(
                                      ({ value }) => value === true
                                    );
                                  if (checkLeadQualitySelected.length > 0) {
                                    setListOfDropDown((pre) => {
                                      pre[5].select = true;
                                      return [...pre];
                                    });
                                    if (
                                      selectedListDropDown.find(
                                        (value) => value === "Lead Quality"
                                      ) === undefined
                                    ) {
                                      selectedListDropDown.push(
                                        "Lead Quality"
                                      );
                                    }
                                  } else {
                                    setListOfDropDown((pre) => {
                                      pre[5].select = false;
                                      return [...pre];
                                    });
                                    selectedListDropDown([
                                      ...selectedListDropDown.filter(
                                        (value) => value !== "Lead Quality"
                                      ),
                                    ]);
                                  }
                                }}
                                control={
                                  <Checkbox
                                    sx={{
                                      "& .MuiSvgIcon-root": { fontSize: 28 },
                                    }}
                                  />
                                }
                                label={each.label}
                              />
                            </FormGroup>
                          );
                        })}
                      {showAllStatusDropDown &&
                        allStatusDropDown.map((each, index) => {
                          return (
                            <FormGroup>
                              <FormControlLabel
                                sx={[
                                  {
                                    "& .MuiTypography-root": {
                                      fontFamily: "Inter-Medium !important",
                                      fontStyle: "normal",
                                      fontWeight: "400",
                                      fontSize: "1.6rem !important",
                                      lineHeight: "2.4rem !important",
                                      /* identical to box height, or 150% */

                                      /* Gray/900 */

                                      color: "#101828",
                                    },
                                  },
                                ]}
                                checked={each.value}
                                onChange={(e) => {
                                  setAllStatusDropDown((pre) => {
                                    pre[index].value = e.target.checked;
                                    return [...pre];
                                  });
                                  if (e.target.checked) {
                                    setAllStatusDropDown((pre) => {
                                      pre[index].value = e.target.checked;
                                      selectedStatus.push(each.label);
                                      return [...pre];
                                    });
                                  } else {
                                    setAllStatusDropDown((pre) => {
                                      pre[index].value = e.target.checked;
                                      return [...pre];
                                    });
                                    setSelectedStatus(
                                      selectedStatus.filter(
                                        (status) => status !== each.label
                                      )
                                    );
                                  }
                                  let checkStatusSelected =
                                    allStatusDropDown.filter(
                                      ({ value }) => value === true
                                    );
                                  if (checkStatusSelected.length > 0) {
                                    setListOfDropDown((pre) => {
                                      pre[6].select = true;
                                      return [...pre];
                                    });
                                    if (
                                      selectedListDropDown.find(
                                        (value) => value === "Status"
                                      ) === undefined
                                    ) {
                                      selectedListDropDown.push("Status");
                                    }
                                  } else {
                                    setListOfDropDown((pre) => {
                                      pre[6].select = false;
                                      return [...pre];
                                    });
                                    setSelectedListDropDown([
                                      ...selectedListDropDown.filter(
                                        (value) => value !== "Status"
                                      ),
                                    ]);
                                  }
                                }}
                                control={
                                  <Checkbox
                                    sx={{
                                      "& .MuiSvgIcon-root": { fontSize: 28 },
                                    }}
                                  />
                                }
                                label={each.label}
                              />
                            </FormGroup>
                          );
                        })}
                      {showDates && (
                        <div>
                          <div className={cssClasses.dateDivider}>
                            <div className={cssClasses.label}>Start Date</div>
                            <DateComponent
                              value={selectDates[0].value}
                              minDate={"1 Jan"}
                              onChangeDate={(value) => {
                                console.log(value);
                                setSelectedDate("notNull");
                                setSelectDates((pre) => {
                                  pre[0].value = value;
                                  return { ...pre };
                                });
                                setHelperText((pre) => {
                                  pre.endDate = "";
                                  return { ...pre };
                                });
                              }}
                              helperText={helperText.startDate}
                            ></DateComponent>
                          </div>
                          <div>
                            <div className={cssClasses.label}>End Date</div>
                            <DateComponent
                              value={selectDates[1].value}
                              minDate={"1 Jan"}
                              onChangeDate={(value) => {
                                setSelectedDate("notNull");
                                console.log(selectDates[0].value, value);
                                if (selectDates[0].value === "") {
                                  setHelperText((pre) => {
                                    pre.endDate =
                                      "Please select start date first";
                                    return { ...pre };
                                  });
                                } else {
                                  if (selectDates[0].value > value) {
                                    setHelperText((pre) => {
                                      pre.endDate =
                                        "Select End Date Greater than start Date";
                                      return { ...pre };
                                    });
                                  } else {
                                    setSelectDates((pre) => {
                                      pre[1].value = value;
                                      return { ...pre };
                                    });
                                    setHelperText((pre) => {
                                      pre.endDate = "";
                                      return { ...pre };
                                    });

                                    console.log("hii0");
                                    setListOfDropDown((pre) => {
                                      pre[1].select = true;
                                      return [...pre];
                                    });
                                    selectedListDropDown.push("Date");
                                  }
                                }
                              }}
                              helperText={helperText.endDate}
                            ></DateComponent>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={cssClasses.wrapperDropDownButtons}>
                    <div>
                      <Button
                        style={{
                          color: "#344054",
                          backgroundColor: "#ffffff",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                        }}
                        padding={"0.8rem"}
                        btnName={"Clear"}
                        clicked={() => {
                          clearFilters();
                          getAllSustenanceLeads(
                            0,
                            sendTabValue,
                            search,
                            drpDownSelectedVal,
                            selectDates,
                            null,
                            [],
                            [],
                            [],
                            [],
                            []
                          );
                        }}
                      />
                    </div>
                    <div>
                      <Button
                        style={{
                          color: "#ffffff",
                          backgroundColor: "#1570EF",
                          fontSize: "1.4rem",
                          lineHeight: "2rem",
                        }}
                        padding={"0.8rem"}
                        btnName={"Apply"}
                        clicked={() => {
                          if (
                            selectDates[1].value === "" &&
                            selectedDates !== null
                          ) {
                            setHelperText((pre) => {
                              pre.endDate = "Please Select end Date";
                              return { ...pre };
                            });
                            setShowDates(true);
                          } else {
                            setHelperText((pre) => {
                              pre.endDate = "";
                              return { ...pre };
                            });
                            setShowDates(false);
                          }

                          setShowAllSalesDropDown(false);
                          setShowAllProjectsDropDown(false);
                          setShowAllLeadQualityDropDown(false);
                          setShowAllStatusDropDown(false);

                          setShowDropDown(false);
                          console.log(helperText);
                          if (
                            helperText.startDate === "" &&
                            helperText.endDate === ""
                          ) {
                            setSustenanceLeadsArray([]);
                            setShowDropDown(false);
                            getAllSustenanceLeads(
                              0,
                              sendTabValue,
                              search,
                              drpDownSelectedVal,
                              selectDates,
                              selectedDates,
                              selectedCP,
                              selectedSales,
                              selectedProjects,
                              selectedLeadQuality,
                              selectedStatus
                            );
                          } else {
                            setShowDropDown(true);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </ClickAwayListener>
            )}
          </div>
        </div>
        <div className={cssClasses.wrapperSortDropDown}>
          {/* <div>Filter By</div> */}
          <div className={cssClasses.filterTitle}>Sort by</div>
          <DropDown
            list={[
              "Name Ascending",
              "Name Descending",
              "Latest First",
              "Oldest First",
            ]}
            selectedValue={drpDownSelectedVal}
            onChangeSelect={(_value) => {
              setDrpDownSelectedVal(_value);
              setSustenanceLeadsArray([]);
              getAllSustenanceLeads(
                0,
                sendTabValue,
                search,
                _value,
                selectDates,
                selectedDates,
                selectedCP,
                selectedSales,
                selectedProjects,
                selectedLeadQuality,
                selectedStatus
              );
            }}
            placeHolder={"Select"}
            //style.color is placeHolder's color
            style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
            helperText={""}
          />
        </div>
      </div>
      <div className={cssClasses.wrapperSearchBar}>
        <SearchBar
          id={"leadSearch"}
          placeholder={"Search"}
          value={search}
          search={debouncedFetchSearchData}
          width="100%"
        />
      </div>
    </div>
    <div
      className={cssClasses.wrapperLeads}
      id="scrollableDiv"
      // onScroll={onScroll}
      // ref={scrollRef}
    >
      <InfiniteScroll
        dataLength={SustenanceLeadsArray.length}
        next={getMoreData}
        style={{ display: "flex", flexDirection: "column" }} //To put endMessage and loader to the top.
        hasMore={loadingStatus === 0}
        // loader={<h4>Loading...</h4>}
        scrollableTarget="scrollableDiv"
      >
        {uniqBy(SustenanceLeadsArray,"leadId").map((each, index) => {
          return (
            <div className={cssClasses.wrapperLead} key={`${each}_${index}`}>
              <Leadcard
                leadObj={each}
                claimLead={(e) => {
                  // claimLead(each);
                }}
                tabValue={sendTabValue}
                returnResLeads={funReturnRes}
                // CardType={"SustenanceLeads"}
              />
            </div>
          );
        })}
      </InfiniteScroll>
      {noLeadsPresent === false && (
        <div className={cssClasses.noDataMsg}>
          <div className={cssClasses.emptyIcon}>
            <img src={EmptyListIcon} alt="No FoS" />
          </div>
          <div className={cssClasses.emptyTitle}>No leads found</div>
          <div className={cssClasses.emptySubTitle}>
            To add a new lead, click on
            <div className={cssClasses.addLeadBtn}>
              <Button
                style={{
                  color: "#fff",
                  backgroundColor: "#175CD3",
                  fontSize: "1.6rem",
                  lineHeight: "2.4rem",
                }}
                btnName={"Add Leads"}
                // clicked={() => {
                //   setAddLeadModal(true);
                // }}
                btnIcon={<PlusIcon />}
                iconPosition={"left"}
              >
                {" "}
              </Button>
            </div>
            {/* to add a new Lead */}
          </div>
        </div>
      )}
    </div>
    {addLeadModal && (
      <AddLead
        open={addLeadModal}
        handleClose={() => {
          setAddLeadModal(false);
        }}
        returnRespButton={leadAdded}
      />
    )}
  </div>
  );
}

export default AllLeads;
